export enum PlanItemType {
  field = 'field',
  record = 'record',
  content = 'content',
}
